import { useEffect, useState } from "react";
import { warn, debug } from "rtUtils/logger";
import { useConfigHotspots } from "./config";
import ANALYTICS_EVENTS from "../analyticsEvents";

const createHotspotData = (renderingApi, hotspotConfig, annotation, index) => {
	const { showLabels, size, expandOnClick, showOnHover, showOnLoad, contentFromUserData } = hotspotConfig;
	const { mesh: meshId, label, title, text, offset, size: hsSize, background, color } = annotation;

		const mesh = renderingApi.getMesh(meshId);
		let result;

		if (mesh) {
			const { x, y, z } = mesh.position;
			const trustedOffset = offset || [0, 0, 0];
			const trustedLabel = label ?? (index + 1);

			debug(`assigning hotspot ${trustedLabel} to mesh: '${mesh.name} in position:`, mesh.position);

			result = {
				index,
				id: `${trustedLabel}_${index}`,
				meshId,
				meshName: mesh.name,
				label: showLabels ? trustedLabel : null,
				title: contentFromUserData ? (mesh.userData?.[title] ?? title) : title,
				text: contentFromUserData ? (mesh.userData?.[text] ?? text) : text,
				position: [x + trustedOffset[0], y + trustedOffset[1], z + trustedOffset[2]],
				size: hsSize || size || "medium",
				expandOnClick,
				showOnHover,
				showOnLoad,
				background,
				color
			};
		} else {
			warn(`hotspots mesh with id ${meshId} not found!`)
		}

		return result;
};

const useHotspots = (getIsReady, renderingApi, triggerAnalyticsEvent = null) => {
	const { enabled, ...hotspotConfig } = useConfigHotspots();
	const isReady = getIsReady();
	const [hotspotsData, setHotspotsData] = useState([]);
	const { annotations, showLabels, size, expandOnClick, showOnHover, showOnLoad, contentFromUserData } = hotspotConfig;

	useEffect(() => {
		if (isReady && renderingApi) {
			if (enabled) {
				if (annotations?.length) {
					const data = annotations.map((annotation, index) =>
						createHotspotData(renderingApi, hotspotConfig, annotation, index)
					)
						.filter(Boolean);

					setHotspotsData(data);

					triggerAnalyticsEvent?.(ANALYTICS_EVENTS.HOTSPOTS, {
						hotspotsCount: data.length,
						showLabels,
						showOnHover,
						showOnLoad
					});
				} else {
					warn("hotspots enabled but no annotations found!");
				}
			} else {
				setHotspotsData([]);
			}
		}
	}, [enabled, isReady, renderingApi, annotations, showLabels, size, expandOnClick, showOnHover, showOnLoad, contentFromUserData]);

	return hotspotsData;
};

export default useHotspots;

